import DOMPurify from 'dompurify';
import { InputHTMLAttributes } from 'react';
import clsx from 'clsx';
import { I18n } from 'src/modules/common/components/I18n/I18n.tsx';
import { useBelimoTranslate } from 'src/common/hooks/useBelimoTranslate.ts';

type Props = {
    labelText: string;
    placeholder: string;
    value: string;
    onChange: (value: string) => void;
    className?: string;
} & Omit<InputHTMLAttributes<HTMLTextAreaElement>, 'onChange'>

export const CheckoutComment = ({
    labelText,
    placeholder,
    onChange,
    value,
    className,
    ...rest
} : Props) => {
    const t = useBelimoTranslate();
    return (
        <div
            className={clsx({ 'vss-comment-wrapper': true }, className)}
        >
            <label
                className={clsx({ 'vss-comment__label': true })}
            ><I18n messageId={labelText}/>
            </label>
            <div className="vss-comment">
                <textarea
                    {...rest}
                    name="comment"
                    placeholder={t(placeholder)}
                    maxLength={rest.maxLength ?? 100}
                    onChange={(event) => onChange(event.target.value.slice(0, 100))}
                    value={DOMPurify.sanitize(value)}
                />
            </div>
        </div>
    );
};
